import { render, staticRenderFns } from "./ArticleAdd.vue?vue&type=template&id=faec3696&scoped=true"
import script from "./ArticleAdd.vue?vue&type=script&lang=js"
export * from "./ArticleAdd.vue?vue&type=script&lang=js"
import style0 from "./ArticleAdd.vue?vue&type=style&index=0&id=faec3696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faec3696",
  null
  
)

export default component.exports